<template>
    <div class="mt-26">
        <div class="text-center text-16 font-medium mb-6">
            ระบบจะส่ง OTP ไปที่เบอร์โทรศัพท์มือถือ <br />
            ({{ FilterMobileNoFormat(infoRegister.mobileNo) }})
        </div>
        <div class="mb-4">
            
            <OrangeButton
                :customClass="`w-full py-3 text-14 rounded-10 ${hasFirstReq ? `bg-a-gray-787878` : `bg-a-orange-f36e21` }`"
                @click="getOtpCode()">
                กดรับ OTP
            </OrangeButton>
        </div>
        <div class="text-center text-12 mb-4">
            หากเบอร์โทรศัพท์มือถือไม่ถูกต้อง<br />
            กรุณาติดต่อศูนย์บริการลูกค้าธนชาตประกันภัย โทร <a class="underline" href="tel:023089222">02-308-9222</a>
        </div>
        <div class="flex items-center mb-4 gap-2.5">
            <div class="flex-auto">
                <InputNumber ref="elelCode" v-model:inputValue="states.code" :inputLbl="otpCodeLabel"
                    :errorInfo="errInfo[0]" :isShowError="false" :isSubmitted="isSubmitted" :maxLength="6" hideErrorSpace hideLabel />
            </div>
            <div class="flex-none">
                
                <OrangeButton
                    :customClass="`w-full px-6 py-3 text-14 rounded-10 ${states.code.length != 6 || !hasFirstReq ? `bg-a-gray-787878` : `bg-a-orange-f36e21` }`"
                    @click="validateOtpCode()">
                    ยืนยัน
                </OrangeButton>
            </div>
        </div>
        <div class="text-center text-12 mb-4 leading-relaxed">
            <template v-if="states.invalidOtp">
                <div class="text-a-red-fe2526">
                    ขออภัย รหัส OTP ไม่ถูกต้อง กรุณากดขอรหัสใหม่
                </div>
            </template>
            <template v-else>
                <div v-if="states.running">
                    {{ states.timeRemaining }}
                </div>
                <div v-else>
                    หากท่านไม่ได้รับ OTP ภายใน 1 นาที กรุณากดรับ OTP อีกครั้ง
                </div>
            </template>
        </div>
        <div>
            
            <OrangeButton
                :customClass="`w-full py-3 text-14 rounded-10 ${!isRequestable ? `bg-a-gray-787878` : `bg-a-orange-f36e21` }`"
                @click="clickResendOtp()">
                ขอรหัสใหม่
            </OrangeButton>
        </div>
    </div>
</template>

<script>
import { defineComponent, inject, ref } from 'vue';
import { FormHelper } from '@/helper/FormHelper';
import CacheHelper from '@/helper/CacheHelper';
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import useOtpFlow from "@/helper/composable/useOtpFlow"
import { useTracking } from "@/feature/TrackingFeature"
// component

import InputNumber from '@/components/Input/label/InputNumber.vue';
import Utility from '@/helper/Utility';
import OrangeButton from '../../../../components/Button/OrangeButton.vue';

export default defineComponent({
    props: {
        infoRegister: {
            type: Object
        }
    },
    components: {
        // MainButton,
        InputNumber,
        OrangeButton
    },
    emits: ["success"],
    setup: function (props, ctx) {
        const elelCode = ref(null)
        const modalStore = inject("ModalStore")
        const { loadingModal } = useLoadingModal(modalStore)
        const { states, isRequestable, requestOtp, validateOtp } = useOtpFlow({
            inputCode: elelCode,
            channel: "",
            expiresIn: 60
        })
        const isSubmitted = ref(false)
        const errInfo = ref(FormHelper.genErrorInfo(1))
        const hasFirstReq = ref(false)
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        const otpCodeLabel = {
            name: "กรอกรหัส OTP",
            placeholder: "กรอกรหัส OTP",
            required: "required"
        }
        const cacheLine = ref("")

        const submit = function () {
           
        }
        const initLineId = () => {
            let cache = new CacheHelper();
            cacheLine.value = cache.getCache('line_user_id');
        }

        const getOtpCode = function () {
            if (!isRequestable) {
                tracking.event("register_sms_page", "click_otp", "", "");
            } else {
                tracking.event("register_sms_page", "click_new_otp", "", "");
            }
            if (hasFirstReq.value == false) {
                hasFirstReq.value = true
            }
            // loadingModal.show()
            initLineId()
            requestOtp(props.infoRegister, cacheLine.value).then(() => {
                
            }).finally(() => {
                loadingModal.hide()
            })
        }
        const clickResendOtp = function () {
            tracking.event("register_sms_page", "click_new_otp", "", "");
          
            if (!hasFirstReq.value || states.running) {
                return
            }

            // loadingModal.show()
            requestOtp(props.infoRegister).then(() => {
                
            }).finally(() => {
                loadingModal.hide()
            })
        }

        const validateOtpCode = function () {
            tracking.event("register_sms_page", "click_confirm_otp", "", "");
            console.log(hasFirstReq.value);
            if (Utility.isEmptyStr(states.code) || !hasFirstReq.value) {
                return
            }

            // loadingModal.show()
            validateOtp(states.code).then(() => {
                ctx.emit("success")
                
            }).finally(() => {
                loadingModal.hide()
            })
        }

        return {
            states,
            isSubmitted,
            errInfo,
            otpCodeLabel,
            hasFirstReq,
            elelCode,
            isRequestable,
            submit,
            getOtpCode,
            validateOtpCode,
            clickResendOtp
        }
    }
})
</script>


